import { Navigate, Outlet } from 'react-router-dom';
import { useCityPermissions } from 'hooks/usePermissions';
import { useUser } from 'state/auth';

const PrivateRoute = () => {
  const { user, isUserEmailVerified } = useUser();

  useCityPermissions(); // fetch user available cities

  if (!isUserEmailVerified && user) {
    return <Navigate to="/email-verification" />;
  }

  if (!user) {
    return (
      <Navigate
        to="/login"
        state={{
          // pass in the current pathname, and current queryparams (ie: search)
          from: { pathname: window.location.pathname, search: window.location.search },
        }}
        replace
      />
    );
  }

  return <Outlet />;
};

export default PrivateRoute;
